import React from 'react';
import PropTypes from 'prop-types';

import { FormGroup as MuiFormGroup } from '@material-ui/core';

const FormGroup = ({ children, ...rest }) => {
  return (
    <MuiFormGroup
      {...rest}
    >
      { children }
    </MuiFormGroup>
  )
}

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormGroup;



// WEBPACK FOOTER //
// ./src/components/base/FormGroup/FormGroup.js